const config = {
  axios: {
    // baseURL: 'http://127.0.0.1/api',
    // baseImgUrl: 'http://ar.local/storage'
    baseURL: '/admin/api/v1',
    // baseURL: '/api/admin/api/v1',
    baseImgUrl: '/storage'
  },

  respBody(response) {
    return {
      data: response.data,
      status: response.status,
      headers: response.headers
    }
  },

  respError(error) {
    return {
      status: error.response.status,
      description: error.response.data.detail
    }
  }
}

export default config
